import React, { useCallback, useEffect, useState } from 'react'
// eslint-disable-next-line
// @ts-ignore
import TimerMachine from 'react-timer-machine'

type Props = {
  timeStart: number
  hideSeconds?: boolean
  countdown?: boolean
}

export default function Stopwatch({ timeStart, hideSeconds, ...props }: Props) {
  const [start, setStart] = useState(false) // hack fix timer not starting

  useEffect(() => {
    setStart(true)
  }, [])

  const formatTimer = useCallback(
    (time: any) => {
      return Object.keys(time).reduce((result, unit) => {
        const timeValue = time[unit]
        const isSeconds = unit === 's'
        const isMilliseconds = unit === 'ms'
        if (
          isMilliseconds ||
          (!timeValue && !isSeconds) ||
          (time['m'] > 0 && hideSeconds && isSeconds)
        ) {
          return result
        }
        if (isSeconds) {
          result += (timeValue + unit).padStart(3, '0')
        } else {
          result += timeValue + unit + ' '
        }
        return result
      }, '')
    },
    [hideSeconds],
  )

  return (
    <TimerMachine
      timeStart={timeStart}
      started={start}
      formatTimer={formatTimer}
      {...props}
    />
  )
}
